const FiltersHelper = {
  filterByTargetType: (element = {}, filterText = '') => {
    const filterTextLowerCase = filterText.toLowerCase()
    if (
      (element?.targetBannerGroups?.length &&
        'banner'.includes(filterTextLowerCase)) ||
      (element?.targetMultiStoreOperators?.length &&
        !element?.targetStores?.length &&
        'mso'.includes(filterTextLowerCase)) ||
      (!element?.targetMultiStoreOperators?.length &&
        element?.targetStores?.length &&
        'retailer'.includes(filterTextLowerCase)) ||
      (!element?.targetBannerGroups?.length &&
        !element?.targetMultiStoreOperators?.length &&
        !element?.targetStores?.length &&
        'all'.includes(filterTextLowerCase))
    )
      return element
  },

  filterByTargets: (element = {}, filterText = '') => {
    const filterTextLowerCase = filterText.toLowerCase()
    if (
      !element?.targetMultiStoreOperators?.length &&
      element?.targetStores?.length
    ) {
      for (const store of element?.targetStores) {
        if (store.storeName?.toLowerCase().includes(filterTextLowerCase))
          return element
      }
    } else if (element?.targetBannerGroups?.length) {
      for (const bannerGroup of element?.targetBannerGroups) {
        if (
          bannerGroup.bannerGroupName
            ?.toLowerCase()
            .includes(filterTextLowerCase)
        )
          return element
      }
    } else if (element?.targetMultiStoreOperators?.length) {
      for (const mso of element?.targetMultiStoreOperators) {
        if (
          mso.multiStoreOperatorName
            ?.toLowerCase()
            .includes(filterTextLowerCase)
        )
          return element
      }
    }
  }
}

export default FiltersHelper
